import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as dayjs from "dayjs";
import * as relativeTime from "dayjs/plugin/relativeTime";
import { PrestartDTO } from "src/app/models/dto/prestart.dto";

@Component({
  selector: "app-mant-modal-iniciar",
  templateUrl: "./modal.component.html",
})
export class MantenimientoIniciarModal implements OnInit {
  _fecha: string = "";
  _tiempoDesde: string = "";
  _leido: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<MantenimientoIniciarModal>,
    @Inject(MAT_DIALOG_DATA) public data: PrestartDTO
  ) {}
  public ngOnInit() {
    dayjs.extend(relativeTime);
    this._fecha = dayjs(this.data.Fecha).format("YYYY-MM-DD");
    this._tiempoDesde = dayjs(this.data.Fecha).fromNow();
  }

  public formato() {
    this.dialogRef.close({ option: "f" });
  }

  public recepcion() {
    this.dialogRef.close({ option: "r" });
  }
}
